const getDisplayName = (user) => {
  if (!user) return '';
  const { prefix = '', firstName = '', lastName = '' } = user;
  return `${prefix}${firstName} ${lastName}`;
};

export default getDisplayName;
